import { DataLayerStepNames } from "@/lib/constants";
import { getBaseDataLayerParams, getDataLayerBrand } from "@/lib/utils/dataLayerParams";

import { schedulerSetup } from "../schedulerSetup";

export const reasonForVisitState = schedulerSetup.createStateConfig({
  meta: { componentKey: "reason-for-visit", label: "reasonForVisit", showFooter: true },
  initial: "checkingReason",
  entry: {
    type: "trackUserEvent",
    params: () => ({
      eventType: "reason_for_visit",
    }),
  },
  on: {
    SELECT_REASON: {
      target: ".complete",
      actions: [
        {
          type: "assignReason",
          params: ({ event }) => ({
            reason: event.reason,
          }),
        },
        {
          type: "trackUserEvent",
          params: ({ event }) => ({
            eventType: "reason_for_visit_response",
            eventData: {
              visit_reason: event.reason,
            },
          }),
        },
        {
          type: "dataLayerPush",
          params: ({ context }) => ({
            step_name: DataLayerStepNames.reasonSelect,
            // assignReason runs first, so context already carries the selected reason
            ...getBaseDataLayerParams(context),
          }),
        },
        { type: "pushGbpSchedulingIntent" },
      ],
    },
  },
  states: {
    checkingReason: {
      always: [
        {
          guard: "hasReason",
          actions: {
            type: "dataLayerPush",
            params: ({ context }) => ({
              step_name: DataLayerStepNames.reasonSelect,
              ...getBaseDataLayerParams(context),
            }),
          },
          target: "complete",
        },
        {
          target: "waitingForFacilityAnalytics", // Otherwise, prepare to track page load
        },
      ],
    },
    waitingForFacilityAnalytics: {
      always: {
        guard: ({ context }) => !!context.facility?.code && !!context.facility?.name,
        target: "idle",
        actions: [
          {
            type: "dataLayerPush",
            params: ({ context }) => ({
              language_preference: context.currentLanguage,
              brand: getDataLayerBrand(context.reasonForVisit),
              step_name: DataLayerStepNames.reasonForVisit,
              website_selected_facility_id: context.facility?.code,
              website_selected_facility_name: context.facility?.name,
            }),
          },
        ],
      },
    },
    idle: {},
    complete: { type: "final" },
  },
  onDone: [
    // Slot pre-selected via sessionStorage → skip dateTimeSelection entirely.
    { guard: "hasPreselectedAppointment", target: "patientInformation" },
    { guard: "isSlotFirstFlow", target: "dateTimeSelection" },
    { target: "patientInformation" },
  ],
  // ← no BACK — this is the first real step
} as const);
